import Component from '@glimmer/component';
import { eq } from 'ember-truth-helpers';

import type { CustomEmberTableColumn } from '../../../../types/components/prism/table.ts';
import PrismTableButtonSort from '../button-sort.gts';

type ColumnMeta = {
  isSortable: boolean;
  isSorted?: boolean;
  isSortedAsc?: boolean;
};

function instanceOfColumnMetaInterface(
  columnMeta: unknown,
): columnMeta is ColumnMeta {
  if (columnMeta !== null && typeof columnMeta === 'object') {
    return 'isSortable' in columnMeta;
  }
  return false;
}

interface PrismTableHeadersThSortWrapperSignature {
  Args: {
    column: CustomEmberTableColumn;
    columnMeta: unknown;
  };
  Blocks: {
    default: [];
  };
}

export default class PrismTableHeadersThSortWrapper extends Component<PrismTableHeadersThSortWrapperSignature> {
  get isSortable(): boolean {
    if (instanceOfColumnMetaInterface(this.args.columnMeta)) {
      return this.args.columnMeta.isSortable;
    }
    return false;
  }

  get isSorted(): boolean {
    if (instanceOfColumnMetaInterface(this.args.columnMeta)) {
      return Boolean(this.args.columnMeta.isSorted);
    }
    return false;
  }

  get isSortedAsc(): boolean {
    if (instanceOfColumnMetaInterface(this.args.columnMeta)) {
      return Boolean(this.args.columnMeta.isSortedAsc);
    }
    return false;
  }

  get thSortWrapperClassNames(): string {
    if (
      this.args.column.thComponent ||
      this.args.column.thSortWrapperClassNames
    ) {
      return this.args.column.thSortWrapperClassNames || '';
    }
    // Only apply this class to the th element if there is no custom thComponent or thSortWrapperClassNames provided
    return 'truncate';
  }

  <template>
    {{#if this.isSortable}}
      <div
        class="prism-table-th-sort-wrapper
          {{if
            (eq @column.textAlign 'center')
            'prism-table-th-sort-wrapper--center'
          }}
          {{if
            (eq @column.textAlign 'right')
            'prism-table-th-sort-wrapper--right'
          }}"
        data-test-id="table-header-sort"
      >
        <div class={{this.thSortWrapperClassNames}}>
          {{yield}}
        </div>
        <PrismTableButtonSort
          @isAscending={{this.isSortedAsc}}
          @isSorted={{this.isSorted}}
        />
      </div>
    {{else}}
      <div class={{this.thSortWrapperClassNames}}>
        {{yield}}
      </div>
    {{/if}}
  </template>
}
